import { getAreaComponents, initAreasMethods } from "./areas.helpers";
import utils from "./areas.utils";
import type { InitAreas, Templates } from "./areas.types";

export const initAreas: InitAreas = Components => {
  const AreaComponents = getAreaComponents(Components);
  const templates: Templates = {};
  const methods = initAreasMethods(breakpoints => getTemplates => {
    for (const breakpoint of breakpoints) {
      templates[breakpoint] = getTemplates(AreaComponents, utils);
    }
  });

  return Object.assign(() => ({ AreaComponents, templates }), methods);
};
